import React from "react";
import styled from "styled-components";
import BillingInfo from "./BillingInfo.jsx";
import DownloadReceipts from "./DownloadReceipts.jsx";

const Container = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export default function Receipt({ paymentData }) {
  if (!paymentData) return null;

  const receiptInfo = {
    serviceFeeReceiptUrl: paymentData.serviceFeeReceiptUrl,
    donationFeeReceiptUrl: paymentData.donationFeeReceiptUrl,
    ticketsReceiptUrl: paymentData.ticketsReceiptUrl,
    hasTicketsReceiptPdf: paymentData.hasTicketsReceiptPdf,
    hasServiceFeeReceiptPdf: paymentData.hasServiceFeeReceiptPdf,
    };

  return (
    <Container>
      {paymentData && <BillingInfo data={paymentData} />}
      {<DownloadReceipts receiptUrls={receiptInfo} />}
    </Container>
  );
}
